import api from '.';

export const PERFIL_USUARIO_KVP_ENDPOINT = '/perfil-usuarios/kvp';

export const getAllPerfilUsuariosAsKvpList = async () => {
    const response = await api.get(PERFIL_USUARIO_KVP_ENDPOINT);
    return response;
};
